import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconRain({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.84848 23.8998C8.62655 24.5113 8.93081 24.9092 9.42181 25.0882C9.91281 25.2672 10.4026 25.158 10.6263 24.5465C10.8483 23.935 10.513 22.0933 10.513 22.0933C10.513 22.0933 9.07101 23.2883 8.84908 23.8998H8.84848Z"
        fill="white"
      />
      <path
        d="M14.0325 23.8998C13.81 24.5113 14.1148 24.9092 14.6058 25.0882C15.0968 25.2672 15.5866 25.158 15.8104 24.5465C16.0323 23.935 15.697 22.0933 15.697 22.0933C15.697 22.0933 14.255 23.2883 14.0331 23.8998H14.0325Z"
        fill="white"
      />
      <path
        d="M19.2171 23.8998C18.9945 24.5113 19.2994 24.9092 19.7904 25.0882C20.2814 25.2672 20.7712 25.158 20.9949 24.5465C21.2169 23.935 20.8816 22.0933 20.8816 22.0933C20.8816 22.0933 19.4396 23.2883 19.2177 23.8998H19.2171Z"
        fill="white"
      />
      <path
        d="M21.7595 10.8474C21.7124 10.8474 21.6671 10.8528 21.6205 10.8546C21.0973 8.64541 19.1178 7 16.7487 7C14.2597 7 12.1997 8.81604 11.8095 11.1947C11.4987 11.1082 11.1736 11.0586 10.8341 11.0586C9.11054 11.0586 7.67155 12.262 7.30345 13.8728C5.95574 14.4026 5 15.7109 5 17.2465C5 19.2481 6.62214 20.8708 8.62432 20.8708H21.7601C24.5289 20.8708 26.7727 18.627 26.7727 15.8594C26.7727 13.0918 24.5283 10.8468 21.7601 10.8468L21.7595 10.8474Z"
        fill="white"
      />
    </svg>
  );
}
